import React from "react";
import './index.css'

export default function KeyInfo(props) {
  return (
    <div className="root-keyinfo" style={{display: 'flex', width: '140px', alignItems: 'center', justifyContent: 'space-around'}}>
      <div style={{height: '35px'}}>
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
          <g id="Grupo_321" data-name="Grupo 321" transform="translate(-1226 -649)">
            <g id="Grupo_320" data-name="Grupo 320">
              <rect id="Retângulo_203" data-name="Retângulo 203" width="35" height="35" rx="10" transform="translate(1229 649)" fill="#6E4590"/>
              <g id="Retângulo_204" data-name="Retângulo 204" transform="translate(1226 652)" fill="none" stroke="#6E4590" strokeWidth="1">
                <rect width="35" height="35" rx="10" stroke="none"/>
                <rect x="0.5" y="0.5" width="34" height="34" rx="9.5" fill="none"/>
              </g>
            </g>
            <text id="Q" transform="translate(1240 672)" fill="white" fontSize="15" fontFamily="SegoeUI-Bold, Segoe UI" fontWeight="700"><tspan x="0" y="0">{ props.infoKey }</tspan></text>
          </g>
        </svg>
      </div>
      <div style={{color: '#6E4590', fontSize: '11px', lineHeight: '12px', fontWeight: 'normal', width: '90px'}}>{ props.text }</div>
    </div>
  )
}
